<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center" class="d-flex">
      <v-col cols="1" sm="3" md="4">
        <v-spacer></v-spacer>
      </v-col>
      <v-col cols="10" sm="6" md="4" class="text-center">
        <v-form @submit.prevent="login" v-model="valid" ref="form">
          <v-text-field
            outlined
            label="Номер вашего мобильного"
            placeholder="79131234567(только цифры)"
            prepend-inner-icon="mdi-cellphone-iphone"
            v-model="mobile"
            :rules="[rules.mobile_required, rules.mobile_numbersonly]"
            autofocus
            :append-icon="waitingForVerificationCode ? 'mdi-lead-pencil' : ''"
            :readonly="waitingForVerificationCode"
            class="py-0 white-bg-textfield-style"
            :error-messages="errorMobileMessage"
            @click:append="waitingForVerificationCode = false"
          ></v-text-field>

          <v-text-field
            v-if="waitingForVerificationCode"
            outlined
            label="Код верификации"
            :placeholder="sentToText"
            :rules="[rules.code_required, rules.code_numbersonly]"
            v-model="verificationCode"
            :error-messages="errorCodeMessage"
            counter
            autofocus
            maxlength="6"
            class="py-0 white-bg-textfield-style"
          ></v-text-field>

          <v-btn
            :loading="loadingData"
            :disabled="!valid"
            type="submit"
            name="button"
            color="primary"
            x-large
            class="py-0"
          >Войти в блог</v-btn>
        </v-form>
      </v-col>
      <v-col cols="1" sm="3" md="4">
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import APIService from '@/apiservices/APIService.js'
import { authComputed } from '@/store/helpers.js'

export default {
  data() {
    return {
      verificationCode: '',
      waitingForVerificationCode: false,
      valid: true,
      mobile: '',
      errorMobileMessage: '',
      errorCodeMessage: '',
      loadingData: false,
      sentToText: 'отправлен на ваш мобильный',

      rules: {
        mobile_required: value => !!value || 'Не, без телефона не пущу.',
        mobile_numbersonly: value => {
          const pattern = /^\d+$/
          return pattern.test(value) || 'Ну я же попросил только цифры'
        },
        code_required: value => !!value || 'Код таки нужен',
        code_numbersonly: value => {
          const pattern = /^\d+$/
          return pattern.test(value) || 'Код должен состоять из 6 цифр'
        }
      }
    }
  },
  computed: {
    ...authComputed
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    mobile: function(newVal, oldVal) {
      this.errorMobileMessage = ''
    },
    // eslint-disable-next-line no-unused-vars
    verificationCode: function(newVal, oldVal) {
      this.errorCodeMessage = ''
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },

    login() {
      this.loadingData = true
      this.submited = true
      // Логин вызывается у нас 2 раза.
      // 1. Просто с телефоном и мы смотрим есть такой телефон в базе или нет
      // 2. уже получение токена с пррисланным по СМС кодом
      // для определения того в какой мы сейчас стадии используем waitingForVerificationCode

      if (this.waitingForVerificationCode) {
        // пытаемся получить токен по телефону и коду
        this.dispatchLogin()
      } else {
        //

        //чистим хедер от Authorization. потому что если в хедере протухший access токен, то нам не додут доступ к API
        APIService.clearAuthorizationHeader(null)

        APIService.getUser(this.mobile)
          .then(response => {
            console.log('After getUser', response)
            this.errorMobileMessage = ''
            this.waitingForVerificationCode = true

            // тут мы будем решать посылать код в телеграм или по смс на телефон
            
            let telegraid = response.data.telegramid
            if ( telegraid && telegraid != ''){
              console.log('Sending code to telegram: ', telegraid)
              this.sentToText = 'отправлен в ваш телеграм'
              // делаем запрос в API на отправку кода в телеграм
              APIService.sendVerificationCodeByTelegram(telegraid)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                  this.loadingData = false
               })
                .catch(error => {
                  this.errorMobileMessage =
                    'Ой, мы не смогли послать вам код. Какая-то странная ошибка: ' +
                    error
                 this.loadingData = false
                  console.log('Error sending code by Telegram:', error)
                })
            }else{
              this.sentToText = 'отправлен на ваш мобильный'
              // делаем запрос в API на отправку СМС с кодом
              APIService.sendVerificationCodeByMobile(this.mobile)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                  this.loadingData = false
               })
                .catch(error => {
                  this.errorMobileMessage =
                    'Ой, мы не смогли послать вам код. Какая-то странная ошибка: ' +
                    error
                 this.loadingData = false
                  console.log('Error sending SMS code:', error)
                })
              }
          })
          .catch(error => {
            if (error.response && error.response.status === 404) {
              this.errorMobileMessage =
                'К сожалению, мы не нашли ваш телефон в нашей базе. Если вам интересен наш блог, то обязательно напишите нам, и мы с радостью вас добавим!'
            } else {
              this.errorMobileMessage =
                'Мда. Что-то пошло не так. Не должно быть такой ошибки. Может со связью проблемы? Если это повторится, то пишите нам, будем чинить. Ошибка:' +
                error
            }
            this.loadingData = false
            console.log('There was an error:', error.response)
          })
      }
    },
    dispatchLogin() {
      console.log('In dispatch login')
      console.log('Verification code:', this.verificationCode)
      this.$store
        .dispatch('login', {
          mobile: this.mobile,
          code: this.verificationCode
        })
        .then(() => {
          const gotoURL = this.$store.getters.getURLtogoAfterLogin

          if (gotoURL && gotoURL != '/logout' && gotoURL != '/login') {
            this.$router.push(gotoURL)
          } else {
            this.$router.push('/new/')
          }
        })
        .catch(error => {
          console.log('Error in dispatch login:', error)
          if (error.response && error.response.status === 400) {
            this.errorCodeMessage =
              'Не, код не подходит. Проверьте правильно ли вы его ввели и попробуйте войти еще раз.'
          } else {
            this.errorCodeMessage =
              'Какая-то неведомая ошибка приключилась. Придется разбираться. Ошибка: ' +
              error
          }
          this.loadingData = false
        })
    }
  }
}
</script>

<style scoped>
.white-bg-textfield-style >>> .v-input__slot {
  background: white;
}
</style>
